import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 text-white">
      <div className="w-full px-4 md:px-6 py-16">
        <div className="max-w-[1200px] mx-auto">
          <div className="mb-12">
            <h3 className="font-heading text-4xl font-bold tracking-tight">yoybuyspreadsheet</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-16">
            <div>
              <p className="text-white/70 text-sm leading-relaxed max-w-xs">
                YOYBUY Spreadsheet — удобная система заказов из Китая. Управляйте покупками на Taobao и 1688 без ошибок и переплат.
              </p>
              <div className="flex items-center gap-4 mt-6">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/30 text-white/70 hover:bg-white/10 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-twitter-x-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/30 text-white/70 hover:bg-white/10 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-telegram-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/30 text-white/70 hover:bg-white/10 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/30 text-white/70 hover:bg-white/10 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-youtube-line text-sm"></i>
                </a>
              </div>
            </div>

            <div className="space-y-8">
              <div>
                <p className="text-white/50 text-xs uppercase tracking-wider font-label mb-2">{t('footer.address')}</p>
                <p className="text-white/80 text-sm leading-relaxed">Kaspreadsheet Office<br />Shenzhen, Guangdong<br />China</p>
              </div>
              <div>
                <p className="text-white/50 text-xs uppercase tracking-wider font-label mb-2">{t('footer.phone')}</p>
                <p className="text-white/80 text-sm">+86 755 1234 5678</p>
              </div>
              <div>
                <p className="text-white/50 text-xs uppercase tracking-wider font-label mb-2">{t('footer.email')}</p>
                <p className="text-white/80 text-sm">support@kaspreadsheet.com</p>
              </div>
            </div>

            <div>
              <img
                src="https://readdy.ai/api/search-image?query=Stylish%20modern%20office%20branding%20flatlay%20with%20business%20cards%20and%20elegant%20stationery%20on%20dark%20slate%20surface%2C%20gold%20foil%20accents%2C%20luxury%20corporate%20identity%20photography%2C%20sophisticated%20minimalist%20aesthetic%2C%20professional%20brand%20presentation&width=400&height=500&seq=footer-v2-brand&orientation=portrait"
                alt="YOYBUY brand"
                className="w-full max-w-[240px] rounded-lg object-cover object-top"
              />
            </div>
          </div>

          <div className="border-t border-white/15 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-white/50 text-xs">{t('footer.copyright')}</p>
            <div className="flex items-center gap-6 flex-wrap justify-center">
              <Link to="/" className="text-white/50 text-xs hover:text-white/80 transition-colors cursor-pointer whitespace-nowrap">{t('footer.home')}</Link>
              <Link to="/article/rukovodstvo-yoybuy-spreadsheet" className="text-white/50 text-xs hover:text-white/80 transition-colors cursor-pointer whitespace-nowrap">{t('footer.article')}</Link>
              <Link to="/article/kak-ispolzovat-yoybuy-spreadsheet" className="text-white/50 text-xs hover:text-white/80 transition-colors cursor-pointer whitespace-nowrap">Как использовать</Link>
              <Link to="/article/yoybuy-spreadsheet-vs-superbuy" className="text-white/50 text-xs hover:text-white/80 transition-colors cursor-pointer whitespace-nowrap">YOYBUY vs Superbuy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}